import {
    List, Create, Edit, View, PurchaseReturn, BulkSale
} from '../Components'

export default [
    { path: '/voucher/store/sales', component: List, name: 'voucher.store.sales'},
    {path: '/voucher/store/bulk-sales', component: BulkSale, name: 'voucher.store.bulk.sales'},
    {path: '/voucher/store/sales/create', component: Create, name: 'voucher.store.sales.create'},
    {path: '/voucher/store/purchase-return/create', component: PurchaseReturn, name: 'voucher.store.purchase.return.create'},
    {path: '/voucher/store/sales/:id/edit', component: Edit, name: 'voucher.store.sales.edit'},
    {path: '/voucher/store/sales/:id/view', component: View, name: 'voucher.store.sales.view'},
]